










































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';

import CheckBoxesDropdown from '~/components/partials/CheckBoxesDropdown.vue';
import CheckInput from '~/components/inputs/CheckInput.vue';
import MapOutline from '~/components/icons/MapOutline.vue';
import BlogCard from '~/components/cards/BlogCard.vue';
import LocalisationArticlesMobileModal from '~/components/lists/items/LocalisationArticlesMobileModal.vue';

const Modal = {
  MOBILE_ARTICLES: 'articles',
};

@Component({
  components: { CheckBoxesDropdown, CheckInput, MapOutline, BlogCard, LocalisationArticlesMobileModal },
  computed: {
    ...mapState('explorer', [
      'displayLocalisationMap',
      'mobileLocalisationFiltersModal',
    ]),
  },
})
export default class LocalisationArticles extends Vue {
  @Prop(Array) news: [];

  displayLocalisationMap: boolean;
  mobileLocalisationFiltersModal: string;

  topicTypes: Array<Types.CheckboxElement> = [
    { checked: false, id: 'sport', name: 'Sport' },
    { checked: false, id: 'tips', name: 'Tips' },
  ];

  selectedTopics: Array<Types.CheckboxElement> = [];
  selectedSports: Array<Types.CheckboxElement> = [];

  Modal = Modal;
  modal: any = null;

  @Watch('mobileLocalisationFiltersModal')
  handleModalDisplay (val: string) {
    if (val === Modal.MOBILE_ARTICLES) this.modal = Modal.MOBILE_ARTICLES;
  }

  get sports () {
    /* eslint array-callback-return: 0 */
    const array: any = [];
    this.news.map((n: Types.BlogNews) => {
      n.tags.map((t: any) => {
        array.push(t);
      });
    });

    return array.filter((v: any, i: any, a: any) => a.findIndex((t: any) => (t.id === v.id)) === i);
  }

  handleModalClose () {
    this.modal = null;
    this.$store.commit('explorer/SET_MOBILE_LOCALISATION_FILTERS_MODAL', '');
  }

  /* eslint array-callback-return: 0 */
  populateFilterArray (data: any) {
    const self: any = this;
    const vueData: any = self[data.data];
    const isDuplicated: any = vueData.filter((item: any) => item.id === data.element.id).length === 1;
    if (!isDuplicated) {
      vueData.push(data.element);
    } else {
      vueData.map((filter: any, index: number) => {
        if (filter.id === data.element.id) {
          vueData.splice(index, 1);
        }
      });
    }
    return vueData.slice(0);
  }

  resetFilters () {
    /* eslint no-return-assign: 0 */
    this.selectedTopics = [];
    this.selectedSports = [];
    this.sports.forEach((d: Types.CheckboxElement) => d.checked = false);
    this.topicTypes.forEach((d: Types.CheckboxElement) => d.checked = false);
  }
}
